import {all, takeEvery, select, call, put } from '@redux-saga/core/effects';
import actionTypes from '../actions/actionTypes';
import { planBaseUrl, httpClient } from '../../http-client/http-client';
import { planActions } from '../actions/plans/plans';

const accessTokenSelector = (state) => state.oidc.user.access_token;

function* fetchAvailable(action) {
  const accessToken = yield select(accessTokenSelector);
  const url = `${planBaseUrl}/all`;

  try {
    const data = yield call(httpClient.get, url, accessToken);
    yield put(planActions.fetchAvailableOk(data));
  }
  catch(error) {
    yield put(planActions.fetchAvailableError(error));
  }
}

export function* watchPlans() {
  yield all([
    takeEvery(actionTypes.plan.FETCH_AVAILABLE, fetchAvailable),
  ]);
}